import styled from 'styled-components';
import { COLORS } from '../../../constants/style/color';
import { rem } from '../../../utils/style';

export const AutomationContainer = styled.div`
  background: ${COLORS.White};
  padding: ${rem(40)};
  border: ${rem(1)} solid ${COLORS.OffWhite};
  border-radius: ${rem(6)};
  margin-bottom: ${rem(16)};
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 20px ${COLORS.SoftShadow};

  @media (min-width: 512px) {
    padding: ${rem(30)} ${rem(46)} ${rem(32)} ${rem(50)};
    margin-right: 25%;
  }
`;
